const apiBaseUrl = (
  (import.meta.env.VITE_API_BASE_URL as string | undefined) ?? ""
).replace(/\/+$/, "");

function buildRequestUrl(path: string): string {
  const normalizedPath = path.replace(/^\/+/, "");
  const base = apiBaseUrl || `${window.location.origin}/api`;
  return `${base}/${normalizedPath}`;
}

export async function apiFetchClient(
  path: string,
  options: RequestInit = {},
): Promise<Response> {
  return fetch(buildRequestUrl(path), { ...options, credentials: "include" });
}
